import { uniqueId } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

/**********
 * 机器人满意度
 ***********/
let sortObj = {
    "1": "good_rate", // 好评
    "2": "good_rate",
    "3": "all_num", // 评价量
    "4": "all_num",
    "5": "good_num", // 满意评价数
    "6": "good_num",
    "7": "question_num", // 提问总数
    "8": "question_num",
    "9": "evaluation_rate", // 评价率
    "10": "evaluation_rate"
};

let orderObj = {};

for (let i in sortObj) {
    let num = Number(i);
    // 奇数-升序 偶数-降序
    orderObj[i] = num % 2 === 0 ? "asc" : "desc";
}

// 问题满意度服务端数据格式
function queryQuesSatisfy2Server(reqData) {
    let request = {
        sort_by: reqData.order ? sortObj[reqData.order] : "good_rate",
        order: reqData.order ? orderObj[reqData.order] : "desc",
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        page: reqData.page,
        size: reqData.curPageLen,
        set_id: reqData.sceneId,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 问题满意度客户端数据格式
function satisfyQuesData2Client(result) {
    let data = {
        allQuesNum: result.all_question_count,
        count: result.count,
        hotQuesData: []
    };
    data.hotQuesData =
        result &&
        result.list.map(item => {
            return {
                id: uniqueId(),
                ranking: item.rank,
                question: { value: item.question, tips: i18n.t("zhiji.hotSpot.quesTip") },
                evaNum: item.all_num || "0",
                satisfaction: item.good_rate_print,
                rowId: item.question_id,
                satisfyEvalNum: item.good_num || "0",
                questionNum: item.question_num || "0",
                evalRate: item.evaluation_rate_print,
                addData: {
                    rowId: item.question_id,
                    sceneId: item.set_id
                }
            };
        });

    return data;
}

// 场景满意度服务端数据转换
function querySatisfyScene2Server(reqData) {
    let request = {
        sort_by: reqData.order ? sortObj[reqData.order] : "good_rate",
        order: reqData.order ? orderObj[reqData.order] : "desc",
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        page: reqData.page,
        size: reqData.curPageLen,
        set_level: reqData.sceneLevel,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 问题满意度-场景服务端数据转换
function querySortSetInfo2Server(reqData) {
    let request = {
        sort_by: reqData.order ? sortObj[reqData.order] : "good_rate",
        order: reqData.order ? orderObj[reqData.order] : "desc",
        start_time: reqData.startTime,
        end_time: reqData.endTime,
        channel: getServerComData(reqData).channel,
        question_type: getServerComData(reqData).question,
        language: getServerComData(reqData).lang
    };

    return request;
}

// 转换满意度筛选字段
function getServerComData(reqData) {
    const questionObj = { all: "", initQues: "first_ask", input: "input", click: "click" };
    return {
        channel: !!reqData.channelType && reqData.channelType === "all" ? "" : reqData.channelType,
        question: questionObj[reqData.quesType] || "",
        lang: !!reqData.langType && reqData.langType === "all" ? "" : reqData.langType
    };
}

// 场景满意度客户端数据格式
function satisfySceneData2Client(result) {
    let data = {
        count: result.count,
        hotSceneData: []
    };
    data.hotSceneData =
        result &&
        result.list.map(item => {
            return {
                id: uniqueId(),
                ranking: item.rank,
                classify: item.set_name,
                satisfaction: item.good_rate_print,
                evaNum: String(item.all_num)
            };
        });
    return data;
}

export default {
    queryQuesSatisfy2Server,
    satisfyQuesData2Client,
    querySatisfyScene2Server,
    satisfySceneData2Client,
    querySortSetInfo2Server
};
